module.exports = __webpack_public_path__ + "img/cloth_g1_item_17.b1c178d1.svg";